export default __webpack_public_path__ + "e5967c8779f1db710e56dbcdbcbea07c.svg";